import { useEffect, useState } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Row, Col, Typography, Table, Spin, DatePicker } from 'antd';
import systemActions from '../../redux/systemInfos/actions';
import IntlMessages from '../../components/utility/intlMessages';
import Box from '../../components/utility/box';
import moment from "moment";

const { Title } = Typography;
const { RangePicker } = DatePicker;

const { getLogs, resetLogs } = systemActions;

const DATE_FORMAT = 'YYYY-MM-DD';
const DEFAULT_RECORDS_PER_PAGE = 20;
const DEFAULT_PAGE_SIZE_OPTIONS = [20, 30, 40, 50];
const INIT_PAGE = 1;

function GeneralLogs(props) {
  const [currentPage, setCurrentPage] = useState(INIT_PAGE);
  const [recordsPerPage, setRecordsPerPage] = useState(DEFAULT_RECORDS_PER_PAGE);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const filters = {
      "limit": recordsPerPage,
      "page": currentPage,
      startDate,
      endDate,
    }

    props.getLogs(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleOnChange(values) {
    props.resetLogs();

    const tmp_startDate = values === null || values[0] === null ? null : moment(values[0]).format(DATE_FORMAT);
    const tmp_endDate = values === null || values[1] === null ? null : moment(values[1]).format(DATE_FORMAT);

    setStartDate(tmp_startDate);
    setEndDate(tmp_endDate);
    setCurrentPage(INIT_PAGE);

    const filters = {
      "limit": recordsPerPage,
      "page": INIT_PAGE,
      "startDate": tmp_startDate,
      "endDate": tmp_endDate,
    }

    props.getLogs(filters);
  }

  function updateTableData(pageData) {
    const { current, pageSize } = pageData;
    let newPageNumber = current;

    if (pageSize !== recordsPerPage) newPageNumber = INIT_PAGE;

    const filters = {
      "limit": pageSize,
      "page": newPageNumber,
      startDate,
      endDate
    }

    props.getLogs(filters);
    setCurrentPage(newPageNumber);
    setRecordsPerPage(pageSize);
  }

  const getMessage = (message, containsError) => {
    return containsError
      ? <Typography.Text type={'danger'}>{message}</Typography.Text>
      : <Typography.Text>{message}</Typography.Text>
  }

  const columns = [
    {
      key: "log",
      dataIndex: 'message',
      render: (text, record) => (
        <span style={{ wordWrap: "break-word" }}>
          <IntlMessages id="general.message" />: {getMessage(text, record.containsError)}
        </span>
      ),
    },
  ];

  const tableColumns = columns.map(item => ({ ...item, ellipsis: true }));
  const paginationConfig = {
    showSizeChanger: true,
    defaultPageSize: recordsPerPage,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    current: currentPage,
    total: props.data.numberOfLogs
  };

  // We use table instead of List because of pagination
  return (
    <Spin spinning={props.loading > 0}>
      <Box>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Title level={4} style={{ textAlign: "center" }}>
              <IntlMessages id="homePage.generalLogs.title" />
            </Title>
          </Col>

          <Col span={24}>
            <a href={process.env.REACT_APP_KIBANA_HOST} target="_blank" rel="noopener noreferrer">
              <IntlMessages id="general.lookOnKibana" />
            </a>
          </Col>

          <Col span={24}>
            <RangePicker
              allowEmpty={[true, true]}
              onChange={handleOnChange}
            />
          </Col>

          <Col span={24}>
            <Table
              tableLayout='fixed'
              bordered={true}
              showHeader={false}
              pagination={paginationConfig}
              columns={tableColumns}
              rowKey={(record) => record.id}
              onChange={updateTableData}
              dataSource={props.data.logs}
            />
          </Col>
        </Row>
      </Box>
    </Spin>
  );
}

GeneralLogs.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.number.isRequired,

  getLogs: PropTypes.func.isRequired,
  resetLogs: PropTypes.func.isRequired,
};

GeneralLogs.defaultProps = {
  data: {
    numberOfLogs: 0,
    logs: []
  }
}

const mapActionsToProps = {
  getLogs,
  resetLogs
}

function mapStateToProps(state) {
  return {
    loading: state.SystemInfos.get('loading'),
    data: state.SystemInfos.get('logsData')
  };
}

const connectedDatabases = connect(mapStateToProps, mapActionsToProps)(GeneralLogs);
export default connectedDatabases;